import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TagRecordCategoryEnum } from '../enums/tag-record-category.enum';

/**
 * Tag DTO for records
 */
@CaslSubject(AppSubjectEnum.TAG)
export class TagRecordDto extends BaseDto {
  name!: string;
  notes?: string | null;
  recordCategory!: TagRecordCategoryEnum;
  description?: string | null;
}
